__turbopack_context__.v({
  "auto": "Restaurant-module-scss-module__fYTXYa__auto",
  "gallery_img1": "Restaurant-module-scss-module__fYTXYa__gallery_img1",
  "gallery_img2": "Restaurant-module-scss-module__fYTXYa__gallery_img2",
  "highlights": "Restaurant-module-scss-module__fYTXYa__highlights",
  "plan_sec": "Restaurant-module-scss-module__fYTXYa__plan_sec",
  "plan_sec_left": "Restaurant-module-scss-module__fYTXYa__plan_sec_left",
  "plan_sec_right": "Restaurant-module-scss-module__fYTXYa__plan_sec_right",
  "restasurant_main": "Restaurant-module-scss-module__fYTXYa__restasurant_main",
  "restaurant_sec": "Restaurant-module-scss-module__fYTXYa__restaurant_sec",
  "restaurnat_left": "Restaurant-module-scss-module__fYTXYa__restaurnat_left",
  "restaurnat_right": "Restaurant-module-scss-module__fYTXYa__restaurnat_right",
  "safety_first_sec": "Restaurant-module-scss-module__fYTXYa__safety_first_sec",
  "safety_sec_content": "Restaurant-module-scss-module__fYTXYa__safety_sec_content",
  "safety_sec_content_card": "Restaurant-module-scss-module__fYTXYa__safety_sec_content_card",
  "speciality_child": "Restaurant-module-scss-module__fYTXYa__speciality_child",
  "speciality_child_left": "Restaurant-module-scss-module__fYTXYa__speciality_child_left",
  "speciality_child_left_two": "Restaurant-module-scss-module__fYTXYa__speciality_child_left_two",
  "speciality_child_right": "Restaurant-module-scss-module__fYTXYa__speciality_child_right",
  "speciality_sec": "Restaurant-module-scss-module__fYTXYa__speciality_sec",
  "stay_left": "Restaurant-module-scss-module__fYTXYa__stay_left",
  "stay_main": "Restaurant-module-scss-module__fYTXYa__stay_main",
  "stay_right": "Restaurant-module-scss-module__fYTXYa__stay_right",
  "stay_sec": "Restaurant-module-scss-module__fYTXYa__stay_sec",
  "stay_slider_child": "Restaurant-module-scss-module__fYTXYa__stay_slider_child",
  "story_sec": "Restaurant-module-scss-module__fYTXYa__story_sec",
});
